export default __webpack_public_path__ + "static/media/news.d7c1b635.png";